export const getBem = <B extends string>(blockClassName: B) =>
  ({
    block: blockClassName,
    element: <E extends string>(element: E): `${B}__${E}` => `${blockClassName}__${element}`,
    modifier: <M extends string>(modifier: M): `${B}--${M}` => `${blockClassName}--${modifier}`,
    elementModifier: <E extends string, M extends string>(element: E, modifier: M): `${B}__${E}--${M}` => 
        `${blockClassName}__${element}--${modifier}`,
  } as const);
